// 移动端首页
<template>
  <div class="cmain">
    <mheader></mheader>
    <div class="topimg"></div>
    <div class="center">
      <ul class="xiangqing">
        <li class="xiangqingList">
          <div class="right">
            <img src="../../assets/img/首页/38c2c01a33c38ab63f9f44b1e087eb7a@2x.png" class="main_img" />
          </div>
          <div class="left">
            <h2 class="xiangqingTitle">工程项目质量全面提升过程咨询</h2>
            <p class="xiangqingMsg">
              以工程项目为服务对象，以鲁班奖创建为目标，通过了解项目基本情况、匹配专家、拟定咨询建议书，
              四次现场和若干次在线和现场节点咨询，为客户提供技术、质量、安全、绿色施工、科技创新、管理提升等全过程技术支持，帮助客户强化质量意识、改善管理、完善工艺，持续改进、过程提升、一次成优。
            </p>
            <div class="more" @click="project">查看更多+</div>
          </div>
        </li>
        <li class="xiangqingList">
          <div class="right">
            <img src="../../assets/img/首页/5316a45cf639d6ff1456aaf6463895ff.png" class="main_img" />
          </div>
          <div class="left">
            <h2 class="xiangqingTitle">专项培训</h2>
            <div class="zxpx">
              <span class="blue"></span>工程项目培训
            </div>
            <div class="zxpx">
              <span class="blue"></span>行业前沿技术培训
            </div>
            <div class="more onemore" @click="train">查看更多+</div>
          </div>
        </li>
        <li class="xiangqingList">
          <div class="right">
            <img src="../../assets/img/首页/1b05e1d5fd56182e60c301d30381fba4.png" class="main_img" />
          </div>
          <div class="left">
            <h2 class="xiangqingTitle">项目信息化建设</h2>
            <p class="xiangqingMsg">
              以工程项目为服务对象，通过云计算、大数据、物联网、人工智能、移动智能终端和5G等信息技术，为企业
              提供投标展示方案、图纸会审、工程量的统计、施工模拟、可视化交底、施工节点分析、综合管线碰撞检测、建筑物全生命周期信息化模型等BIM、智慧工地方面的咨询服务。
            </p>
            <div class="more" @click="information">查看更多+</div>
          </div>
        </li>
        <li class="xiangqingList">
          <div class="right">
            <img src="../../assets/img/首页/3e6632e4465e4d017df985598d87376f.png" class="main_img" />
          </div>
          <div class="left">
            <h2 class="xiangqingTitle">法律服务咨询</h2>
            <p
              class="xiangqingMsg"
            >根据建筑行业发展动态，针对工程招投标、合同谈判与签订，项目实施过程中诸如工期、质量、造价、担保、保险、损害赔偿、工伤、劳务纠纷等方面的问题，为客户提供专业化法律咨询服务。同时，也可为客户提供企业并购、对外投资合作、公司治理等方面的服务咨询。</p>
            <div class="more" @click="law">查看更多+</div>
          </div>
        </li>
        <li class="xiangqingList">
          <div class="right">
            <img src="../../assets/img/首页/6.png" class="main_img" />
          </div>
          <div class="left">
            <h2 class="xiangqingTitle">双重预防体系咨询服务</h2>
            <p
              class="xiangqingMsg"
            >包括安全评估及认证服务，双重预防体系实施，双重预防体系建设咨询、双重预防体系建设培训、双重预防体系平台建设以及不同行业、特殊环境双体系定制开发等内容。 指导企业建立组织机构、完善工作制度，建立健全档案管理制度，风险点排查确定，危险源识别、分析，风险评价，制定风险管控措施；隐患分级与分类，重大隐患治理。</p>
            <div class="more" @click="double">查看更多+</div>
          </div>
        </li>
        <li class="xiangqingList">
          <div class="right">
            <img src="../../assets/img/首页/luban2.png" class="main_img" />
          </div>
          <div class="left">
            <h2 class="xiangqingTitle">项目汇报视频、PPT材料服务</h2>
            <p
              class="xiangqingMsg"
            >由专业团队驻现场进行项目考察、拍摄、素材采集，针对项目优点、难点进行重点刻画表现，以及根据甲方提供图片、视频及文字材料，进行工法申报材料的制作。</p>
            <div class="more" @click="items">查看更多+</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="bottomImg">
      <h2>工程建设全过程咨询服务</h2>
      <p>咨询电话：0371-65353150</p>
    </div>
    <mfooter></mfooter>
  </div>
</template>

<script>
import mheader from "../../components/mobileHF/mHeader";
import mfooter from "../../components/mobileHF/mFooter";
export default {
  props: {},
  data() {
    return {};
  },
  mounted() {
    if (this.isMobile()) {
      this.$router.replace("/mIndex"); //移动端跳转路由
    } else {
      this.$router.replace("/"); //Pc端跳转路由
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    project() {
      this.$router.replace("/mProject");
    },
    train() {
      this.$router.replace("/mTrain");
    },
    information() {
      this.$router.replace("/mInformation");
    },
    law() {
      this.$router.replace("/mLaw");
    },
    double() {
      this.$router.replace("/mDouble");
    },
    items() {
      this.$router.replace("/mItems");
    },
  },
  components: {
    mheader,
    mfooter,
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/mIndex';
</style>
